module.exports = __webpack_public_path__ + "img/addcp2.a289b611.png";